import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SliderComponent.css";

const SliderComponent = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          "https://api.swasthmitra.com/api/category/selected"
        );
        const data = await response.json();

        if (response.ok) {
          setCategories(data.categories);
        } else {
          console.error("Error fetching categories:", data.message);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: false, // Removed auto-scroll functionality
    autoplaySpeed: 3000, // No longer relevant
    nextArrow: null, // Removed the next arrow
    prevArrow: null, // Removed the previous arrow
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show two items per row on tablets
          slidesToScroll: 1,
          arrows: false, // Hide arrows on tablet and mobile view
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // Show one item per row on small mobile devices
          slidesToScroll: 1,
          arrows: false, // Hide arrows on mobile view
        },
      },
    ],
  };

  // Split categories into two halves
  const splitCategories = () => {
    const mid = Math.ceil(categories.length / 2);
    return [categories.slice(0, mid), categories.slice(mid)];
  };

  // Get the two halves of categories
  const [firstHalf, secondHalf] = splitCategories();

  return (
    <div className="slider-container">
      {/* First row slider with the first half of categories */}
      {firstHalf.length > 0 ? (
        <div className="slider-row">
          <Slider {...settings}>
            {firstHalf.map((item) => (
              <div key={item._id} className="slider-item">
                <div className="content-container">
                  <div className="icon">
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="category-icon"
                    />
                  </div>
                  <p className="category-name">{item.name}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <p>Loading categories...</p>
      )}

      {/* Second row slider with the second half of categories */}
      {secondHalf.length > 0 ? (
        <div className="slider-row">
          <Slider {...settings}>
            {secondHalf.map((item) => (
              <div key={item._id} className="slider-item">
                <div className="content-container">
                  <div className="icon">
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="category-icon"
                    />
                  </div>
                  <p className="category-name">{item.name}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <p>Loading categories...</p>
      )}
    </div>
  );
};

export default SliderComponent;
